/* NLC — Shop This Look cart handler.

   Overrides the inline handler in sections/nlc-reviews.liquid by intercepting
   the click in the CAPTURE phase on document.

   Uses the theme's own cart:refresh event (see CartDrawer.onCartRefresh in
   assets/cart.js). That handler re-fetches ?section_id=cart-drawer, replaces the
   contents of #CartDrawer-cart-drawer with the server-rendered markup, and then
   calls show() — which only traps focus once the drawer is actually open.

   DO NOT publish cartUpdate from here. CartItems.onCartUpdate ends in an
   unguarded FoxTheme.a11y.trapFocus(cartDrawer, cartDrawer.querySelector(...)).
   With the drawer closed, that querySelector returns null, trapFocus throws on
   .focus, and the handler dies after blanking the drawer but before refilling it
   — the "opens empty, $0" bug. cart:refresh has no such problem.

   Do not hand-paint the drawer regions either: the free shipping bar and the
   recommendations render inside CartDrawerBody, so a partial paint desyncs them.
   Let the server render the whole shell. */
(function () {
  var LOG = '[NLC Shop This Look]';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.nlc-rev5__stl-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    if (btn.classList.contains('is-adding')) return;

    var ids = (btn.getAttribute('data-variant-ids') || '')
      .split(',').map(Number).filter(Boolean);
    if (!ids.length) return;

    var label = btn.querySelector('.nlc-rev5__stl-label');
    var orig = label ? label.textContent : '';
    btn.classList.add('is-adding');
    if (label) label.textContent = 'Adding...';

    function reset(delay) {
      setTimeout(function () {
        if (label) label.textContent = orig;
        btn.classList.remove('is-adding');
      }, delay);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: ids.map(function (v) { return { id: v, quantity: 1 }; }) })
    })
      .then(function (r) {
        return r.text().then(function (text) {
          var data = null;
          try { data = JSON.parse(text); } catch (err) {}
          if (!r.ok) {
            console.error(LOG, 'add.js ' + r.status, data || text, 'variant ids:', ids);
            var e2 = new Error((data && (data.description || data.message)) || ('HTTP ' + r.status));
            e2.addFailed = true;
            throw e2;
          }
          return data || {};
        });
      })
      .then(function () {
        if (label) label.textContent = '\u2713 Added!';

        /* The theme re-renders the drawer from the server and opens it. */
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { open: true }
        }));

        /* Header count bubble — cart:refresh only re-renders the drawer. */
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('.cart-count, .cart-count-bubble span, [data-cart-count]')
              .forEach(function (el) { el.textContent = cart.item_count; });
            document.documentElement.classList.toggle('cart-has-items', cart.item_count > 0);
          })
          .catch(function (err) { console.warn(LOG, 'count update failed', err); });

        reset(2000);
      })
      .catch(function (err) {
        if (err && err.addFailed) {
          if (label) label.textContent = 'Unavailable';
          reset(2500);
        } else {
          console.error(LOG, 'post-add step failed (item IS in cart)', err);
          if (label) label.textContent = '\u2713 Added!';
          reset(2000);
        }
      });
  }, true); // capture
})();
